import axios from "axios";
import Modal from "@shared/v2/Modal";
import TaskForm from "./TaskForm";
import RescheduleModal from "./RescheduleModal";
import DeleteModal from "./DeleteModal";
import ReassignModal from "./ReassignModal";
import { stripHtml } from "../../shared/Utilities";
import Details from "../../PersonDetail/components/tasks/Details";
import { adaptPostPutTask } from "../../TransactionDetailsPage/Main/Tasks/api/apiAdapters";
import dayjs from "@shared/dayjs";

export function showSelectAllPopover(e) {
  this.setState({ selectAllTarget: e.target, showSelectAll: true });
}

export function closeSelectAllPopover(e) {
  this.setState({ selectAllTarget: null, showSelectAll: false });
}

export function showModal() {
  this.setState({ showModal: true });
}

export function showModalComplete() {
  this.setState(({ task }) => ({ task: { ...task, state: "completed" }, showModal: true }));
}

export function closeModal(response) {
  this.setState({ showModal: false });
}

export function showDetailModal() {
  this.setState({ showDetailModal: true });
}

export function closeDetailModal() {
  this.setState({ showDetailModal: false });
}
export function swapModals() {
  this.setState({ showDetailModal: false, showModal: true });
}
export function showDeleteModal() {
  this.setState({ showDeleteModal: true });
}

export function closeDeleteModal() {
  this.setState({ showDeleteModal: false });
}

export function handleTaskChange(e) {
  const { task } = this.state;
  const key = e.target.name;
  const value = e.target.type == "checkbox" ? e.target.checked : e.target.value;

  if (key == "multi_select") {
    return this.handleMultiSelect(value);
  }

  if (key === "recurring_every_so_many_days" || key === "recurring_day_of_week") {
    return this.handleRecurrence(key, value);
  }

  if (key === "assigned_to_user_id" && value === "anyone") {
    return this.handleAssignedToUser(key, value);
  }

  task[key] = value;

  this.setState({ task });
  if (key == "complete" && task["complete"] == true) {
    this.completeTask(this.state.task);
  }
  if (key == "complete" && task["complete"] == false) {
    this.uncompleteTask(this.state.task);
  }
}

export function handleAssignedToUser(key, value) {
  const { task } = this.state;
  task["assigned_to_user_id"] = null;
  this.setState({ task });
}

export function handleRecurrence(key, value) {
  var { task } = this.state;
  if (key === "recurring_every_so_many_days") {
    task.recurring_day_of_week = null;
    task.recurring_every_so_many_days = value;
  }
  if (key === "recurring_day_of_week") {
    task.recurring_every_so_many_days = null;
    task.recurring_day_of_week = value;
  }
  this.setState({ task });
}

export function handleMultiSelect(value) {
  let { task } = this.state;
  task["multi_select"] = value;
  this.setState({ ...this.state, ...task });
  this.multiSelectWatcher();
}

export function weeklyOptions() {
  return {
    0: "On Sunday",
    1: "On Monday",
    2: "On Tuesday",
    3: "On Wednesday",
    4: "On Thursday",
    5: "On Friday",
    6: "On Saturday",
  };
}

export function completeAndEditAppointment() {
  this.setState(({ task }) => ({ task: { ...task, state: "completed" } }));
}

export function renderDetailModal() {
  var { task } = this.props;
  // FIXME(rubenochiavone): Add prop to Details component to toggle Modal visibility so that
  // animation can work. Short-circuiting the rendering of Modal, like in the line below, prevents
  // animation from working.
  return (
    this.state.showDetailModal && (
      <Details
        type="Task"
        task={task}
        closeTaskDetails={this.closeDetailModal}
        editTask={this.swapModals}
        completeTaskFromDetails={this.completeTask}
      />
    )
  );
}

export function renderModal() {
  const { showModal, task, taskable } = this.state;

  const onClose = () => this.setState({ showModal: false });

  return (
    <Modal
      show={showModal}
      onHide={onClose}
      id="edit-task-modal"
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-max-w-[750px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
    >
      <TaskForm showHeader task={task} taskable={taskable} onClose={onClose} editTaskFor />
    </Modal>
  );
}

export function multiSelectWatcher() {
  this.setState(({ tasks }) => ({
    header_buttons: tasks.filter((t) => t.multi_select && t.type !== "Appointment").length > 0,
  }));
}

export function selectAll() {
  this.setState(
    ({ tasks }) => ({
      selectAll: true,
      selectNone: false,
      tasks: tasks.map((task) => taskMultiSelect(task, true)),
      showSelectAll: false,
    }),
    () => this.multiSelectWatcher(),
  );
}

export function selectNone() {
  this.setState(
    ({ tasks }) => ({
      selectNone: true,
      selectAll: false,
      tasks: tasks.map((task) => taskMultiSelect(task, false)),
      showSelectAll: false,
    }),
    () => this.multiSelectWatcher(),
  );
}

export function taskMultiSelect(task, bool) {
  return { ...task, multi_select: task.type === "Appointment" ? false : bool };
}

export function renderReassignModal() {
  return (
    <ReassignModal
      showReassignModal={this.state.showReassignModal}
      selectedTasks={this.selectedTasks()}
      assignedToUserId={this.state.assigned_to_user_id}
      form={this.state}
      dropdownUpdater={this.handleState}
      onClose={this.closeReassignModal}
      reassignTasksHandler={this.reassignTasks}
    />
  );
}

export function showReassignModal() {
  this.setState({ ...this.state, showReassignModal: true });
}
export function closeReassignModal() {
  this.selectNone();
  this.setState({ showReassignModal: false });
  this.multiSelectWatcher();
}

export function showRescheduleModal() {
  this.setState({ ...this.state, showRescheduleModal: true });
}
export function closeRescheduleModal() {
  this.selectNone();
  this.setState({ ...this.state, showRescheduleModal: false });
  this.multiSelectWatcher();
}

export function selectedTasks() {
  const { tasks } = this.state;
  return tasks.filter((task) => task.multi_select && task.type !== "Appointment");
}
export function setAgentsForModal() {
  var agents = [];
  for (var obj in this.props.agents) {
    var agent = this.props.agents[`${obj}`];
    agents.push({ label: agent["full_name"], value: agent["uuid"] });
  }
  return agents;
}
export function renderDeleteModal() {
  return (
    <DeleteModal
      showDeleteModal={this.state.showDeleteModal}
      closeDeleteModal={this.closeDeleteModal}
      deleteTasksHandler={this.deleteTasks}
      submitDisabled={this.state.submitDisabled}
      type={
        typeof this.selectedTasks === "function" && this.selectedTasks().length > 0
          ? "Tasks"
          : this.state?.task?.type === "Appointment"
            ? "Appointment"
            : "Task"
      }
    />
  );
}

export function renderRescheduleModal() {
  return (
    <RescheduleModal
      selectedTasks={this.selectedTasks()}
      showRescheduleModal={this.state.showRescheduleModal}
      closeRescheduleModalHandler={this.closeRescheduleModal}
      rescheduleDate={this.state.reschedule_date}
      rescheduleDateHandler={this.handleRescheduleDate}
      rescheduleTasksHandler={this.rescheduleTasks}
    />
  );
}

export function handleState(e) {
  const { state } = this;
  const key = e.target.name;
  const value = e.target.type == "checkbox" ? e.target.checked : e.target.value;

  state[key] = value;
  this.setState({ ...this.state, ...state });
}

export function handleRescheduleDate(e) {
  this.setState({ reschedule_date: dayjs(e).format("YYYY-MM-DD") });
}

export async function deleteTasks() {
  this.props.toggleTaskLoader(true);
  await Promise.allSettled(this.selectedTasks().map((task) => this.deleteTask(task, true)));
  this.getTasks();
  this.setState({ selectAll: false, showDeleteModal: false });
}

export function deleteTask(task, bulkOperation = false) {
  let task_id_to_delete = task.id || this.state.task.id;

  if (!bulkOperation) this.setState({ submitDisabled: true });

  return axios({
    method: "delete",
    url: `/tasks/${task_id_to_delete}`,
    headers: {
      "X-CSRF-Token": ReactOnRails.authenticityToken(),
    },
  }).then(() => {
    if (!bulkOperation) {
      this.setState({ showDeleteModal: false, submitDisabled: false });
      this.getTasks();
    }
    let event = {
      target: {
        name: "state",
        value: "archived",
      },
    };
    let taskChangeEvent = new Event("task:count_change");
    window.dispatchEvent(taskChangeEvent);
  });
}
export async function completeTasks() {
  this.props.toggleTaskLoader(true);
  await Promise.allSettled(this.selectedTasks().map((task) => this.completeTask(task, true)));
  this.getTasks();
  this.setState({ selectAll: false });
}

export async function uncompleteTasks() {
  this.props.toggleTaskLoader(true);
  await Promise.allSettled(this.selectedTasks().map((task) => this.uncompleteTask(task, true)));
  this.getTasks();
  this.setState({ selectAll: false });
}

export async function reassignTasks() {
  this.props.toggleTaskLoader(true);
  await Promise.allSettled(
    this.selectedTasks().map((task) => this.reassignTask(task, this.state.assigned_to_user_id, true)),
  );
  this.getTasks();
  this.setState({ selectNone: false }, () => this.closeReassignModal());
}

const clientFinder = (agents, clientUuid) => {
  const agent = agents.find((agent) => agent.value === clientUuid);
  return agent || "";
};

const returnAppointmentType = (appointmentType) => {
  const simpleAppointments = [
    "General",
    "Follow Up",
    "Client Meeting",
    "Buyer/Listing Consultation",
    "Recruiting Appointment",
  ];
  return simpleAppointments.includes(appointmentType) ? "Appointment" : appointmentType;
};

export function handleGoogleCalendar(task, agents, user, contactEmail, addTo) {
  const taskDetails = task.name;
  const location = task.location;
  const scheduledTime = task.scheduled_time;
  const clientUuid = task.assigned_to_user_id;
  const agentEmail = user ? encodeURIComponent(user.email) : "";
  const appointmentType = task.appointment_type;
  const taskableName = task.taskable_name.length ? task.taskable_name : "";
  const scheduledDateTimeStart = dayjs.unix(scheduledTime).format("YYYYMMDDTHHmmSSZ");
  const scheduledDateTimeEnd = dayjs.unix(scheduledTime).add(0.5, "hour").format("YYYYMMDDTHHmmSSZ");
  const scheduledDateTimeEnglishFormatStart = dayjs.unix(scheduledTime).format("ddd, MMM D, YYYY h:mm A");
  const currentTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const client = clientFinder(agents, clientUuid);
  const clientEmail = encodeURIComponent(client.email);
  const title = `${returnAppointmentType(appointmentType)}: ${taskableName} And ${client.label}`;
  const sendableEmail = encodeURIComponent(contactEmail || task.taskable_email);
  const emails = [clientEmail, agentEmail, sendableEmail].filter(Boolean).join(",");
  if (addTo) {
    window.open(
      `https://calendar.google.com/calendar/u/0/r/eventedit?text=${title}&location=${
        location || "Location"
      }&details=Details:+${taskDetails}%0A%0ADate+and+Time:+${scheduledDateTimeEnglishFormatStart}%0A%0AGuests:%0A+${
        client.label
      }: ${clientEmail}%0A+${taskableName}${
        `: ${sendableEmail}` || ""
      }+&add&dates=${scheduledDateTimeStart}/${scheduledDateTimeEnd}&add=${emails}&ctz=${currentTz}`,
      "_blank",
    );
  }
}

export const tryCatchHandlr = async (promise) => {
  try {
    const data = await promise;
    return [data, null];
  } catch (err) {
    return [null, err];
  }
};

export async function createTask(
  task,
  listingUuid,
  agents,
  user,
  contactEmail,
  addTo,
  handleAgreementCallback = () => false,
) {
  const { v4TaskApi } = this.props;
  const taskUpdateEvent = new Event("task:update");
  const taskChangeEvent = new Event("task:count_change");
  const taskListener = new Event("task:polymoprhic_count_change");
  const apiPath = v4TaskApi ? "/api/v4/transactions/tasks" : "/tasks";
  const data = {
    task: { ...task, completed: task.completed ? "true" : task.completed },
    authenticity_token: ReactOnRails.authenticityToken(),
  };
  if (listingUuid) data.uuid = listingUuid;

  this.setState({ disabledButton: true, errors: "" });

  return axios
    .post(apiPath, data)
    .then(({ data }) => {
      this.handleGoogleCalendar(task, agents, user, contactEmail, addTo);
      window.dispatchEvent(taskUpdateEvent);
      window.dispatchEvent(taskChangeEvent);
      window.dispatchEvent(taskListener);
      this.setState({ disabledButton: false });
      this.props.onClose(data);
      handleAgreementCallback();
    })
    .catch((err) => {
      this.setState({ disabledButton: false, errors: parseErrors(err) });
    });
}

export function updateTask(task, listingUuid, bulkOperation = false, agents, user, contactEmail, addTo) {
  const { v4TaskApi } = this.props;
  const taskUpdateEvent = new Event("task:update");
  const taskChangeEvent = new Event("task:count_change");
  const taskListener = new Event("task:polymoprhic_count_change");
  const apiPath = v4TaskApi ? `/api/v4/transactions/tasks/${listingUuid}` : `/tasks/${task.id}`;
  const data = {
    task: { ...task, completed: task.completed ? "true" : task.completed, run: !task.completed },
    authenticity_token: ReactOnRails.authenticityToken(),
  };
  if (listingUuid) data.task.uuid = listingUuid;
  if (v4TaskApi) data.task = adaptPostPutTask(data.task);

  this.setState({ disabledButton: true });

  return axios
    .patch(apiPath, data)
    .then(({ data }) => {
      this.handleGoogleCalendar(task, agents, user, contactEmail, addTo);
      if (!bulkOperation) {
        window.dispatchEvent(taskUpdateEvent);
      }
      window.dispatchEvent(taskChangeEvent);
      window.dispatchEvent(taskListener);
      this.setState({ disabledButton: false });
      this.props.onClose?.(data);
    })
    .catch((err) => {
      this.setState({ disabledButton: false, errors: parseErrors(err) });
      throw err;
    });
}

export function reassignTask(task, assigned_to_user_id, bulkOperation = false) {
  task.assigned_to_user_id = assigned_to_user_id;
  if (task.assigned_to_user_id == "anyone") {
    task.assigned_to_user_id = null;
  }
  return this.updateTask(task, null, bulkOperation);
}

export async function rescheduleTasks(task, reschedule_date) {
  this.props.toggleTaskLoader(true);
  await Promise.allSettled(this.selectedTasks().map((task) => this.rescheduleTask(task, true)));
  this.getTasks();
  this.setState({ ...this.state, selectNone: false }, () => this.closeRescheduleModal());
}

export function rescheduleTask(task, bulkOperation = false) {
  task.due_on = this.state.reschedule_date;
  return this.updateTask(task, null, bulkOperation);
}

export function completeTask(task, bulkOperation = null) {
  task.type == "Appointment" ? (bulkOperation = true) : (bulkOperation = false);
  this.setState({ task: { ...task, state: "completed" } });
  return axios
    .patch(`/tasks/${task.id}/complete`, {
      task,
      authenticity_token: ReactOnRails.authenticityToken(),
    })
    .then(() => {
      const taskChangeEvent = new Event("task:count_change");
      const polymorphicChange = new Event("task:polymorphic_count_change");
      window.dispatchEvent(polymorphicChange);
      window.dispatchEvent(taskChangeEvent);
      if (!bulkOperation) {
        const taskUpdateEvent = new Event("task:update");
        window.dispatchEvent(taskUpdateEvent);
      }
    });
}

export function uncompleteTask(task, bulkOperation = false) {
  const formData = Object.assign({}, this.state.task);
  this.setState({ task: { ...this.state.task, state: "running" } });
  return axios
    .patch(`/tasks/${task.id}/uncomplete`, {
      task: formData,
      authenticity_token: ReactOnRails.authenticityToken(),
    })
    .then((response) => {
      let taskChangeEvent = new Event("task:count_change");
      let polymorphicChange = new Event("task:polymorphic_count_change");
      window.dispatchEvent(polymorphicChange);
      window.dispatchEvent(taskChangeEvent);
      if (!bulkOperation) {
        let taskUpdateEvent = new Event("task:update");
        window.dispatchEvent(taskUpdateEvent);
      }
    });
}

export function replaceURLWithHTMLLinks(text) {
  let replacedText, replacePattern1, replacePattern2, strippedText;
  strippedText = stripHtml(text);
  //URLs starting with http://, https://, or ftp://
  replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
  replacedText = strippedText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');
  //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
  replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
  return replacedText;
}

export function nlToBr(text) {
  return text.replace(/\r\n|\n\r|\r|\n/g, "<br />");
}

export const parseErrors = (err) => {
  const genericError = "Uh-oh! Something went wrong.";
  if (!/text|json/.test(err.response?.headers["content-type"])) {
    return [genericError];
  }
  const parsedError = String(err.response?.data || "").split(" - ")[1];
  if (parsedError?.startsWith("[")) {
    return JSON.parse(parsedError);
  } else {
    return [parsedError || err.message || genericError];
  }
};
